export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/Warning.b2415b0b.svg","height":24,"width":24};